import { Alert, Stack } from "@mui/material";

import type { ClientCdpOnlineChannel } from "../../../../lib/api/types";
import Client360ChannelFieldGrid from "./Client360ChannelFieldGrid";

function display(value: string | number | null | undefined, suffix = "") {
    if (value === null || value === undefined || value === "") {
        return "—";
    }

    return `${value}${suffix}`;
}

export default function Client360OnlineChannelTab({ channel }: { channel: ClientCdpOnlineChannel }) {
    if (!channel.hasData) {
        return <Alert severity="info">Няма онлайн активност за този клиент.</Alert>;
    }

    return (
        <Stack spacing={2}>
            {channel.dataSourceNote ? <Alert severity="warning">{channel.dataSourceNote}</Alert> : null}
            <Client360ChannelFieldGrid
                title="Онлайн"
                subtitle="Поръчки от ERP (WooCommerce канал); пълен Woo профил — при следващ sync."
                rows={[
                    { label: "Онлайн ID (ERP)", value: display(channel.wooUserId) },
                    { label: "Имейл", value: display(channel.email) },
                    { label: "Регистрация", value: display(channel.registeredAt) },
                    { label: "Последен вход", value: display(channel.lastLoginAt) },
                    { label: "Бюлетин", value: display(channel.newsletterStatus) },
                    { label: "Брошура", value: display(channel.brochureStatus) },
                    { label: "Брой онлайн поръчки", value: display(channel.orderCount) },
                    { label: "Оборот онлайн", value: display(channel.orderTurnover?.toLocaleString("bg-BG"), " €") },
                    { label: "Последна поръчка", value: display(channel.lastOrderAt) },
                    { label: "Желани продукти", value: display(channel.wishlistCount) },
                ]}
            />
        </Stack>
    );
}
